import { Table } from '@mantine/core';

const NoBorderTableCell = ({ children, ...otherProps }: any) => {
  return (
    <Table.Td {...otherProps} style={{ border: 'none' }}>
      {children}
    </Table.Td>
  );
};
export default NoBorderTableCell;
